import './events.css';
import EventItem from "./EventItem";
import OverflowScrolling from 'react-overflow-scrolling';
import {useContext, useEffect, useState} from "react";
import LanguageContext from "../../LanguageContext/LanguageContext";
import Slider from "react-slick";
export default function EventsBox(){
    const { translations } = useContext(LanguageContext);

    const arrEvent = [
        {
            "title" : translations.eventsList[15].title,
            "location" : translations.eventsList[15].location,
            "date" : translations.eventsList[15].date,
            "img" : require("../../images/bangkok-v3.jpg")
        },
        {
            "title" : translations.eventsList[14].title,
            "location" : translations.eventsList[14].location,
            "date" : translations.eventsList[14].date,
            "img" : require("../../images/barcelona-v1.jpg")
        },
        {
            "title" : translations.eventsList[13].title,
            "location" : translations.eventsList[13].location,
            "date" : translations.eventsList[13].date,
            "img" : require("../../images/dubai-2-v.jpg")
        },
        {
            "title" : translations.eventsList[12].title,
            "location" : translations.eventsList[12].location,
            "date" : translations.eventsList[12].date,
            "img" : require("../../images/Bangkok-venice.jpg.webp")
        },
        {
            "title" : translations.eventsList[11].title,
            "location" : translations.eventsList[11].location,
            "date" : translations.eventsList[11].date,
            "img" : require("../../images/budda.avif")
        },
        {
            "title" : translations.eventsList[10].title,
            "location" : translations.eventsList[10].location,
            "date" : translations.eventsList[10].date,
            "img" : require("../../images/img_pln.jpg")
        },
        {
            "title" : translations.eventsList[9].title,
            "location" : translations.eventsList[9].location,
            "date" : translations.eventsList[9].date,
            "img" : require("../../images/wael-hneini-QJKEa9n3yN8-unsplash.jpg")
        },
        {
            "title" : translations.eventsList[8].title,
            "location" : translations.eventsList[8].location,
            "date" : translations.eventsList[8].date,
            "img" : require("../../images/kyiv-xkfWHbjlKhI.jpg")
        },
        {
            "title" : translations.eventsList[7].title,
            "location" : translations.eventsList[7].location,
            "date" : translations.eventsList[7].date,
            "img" : require("../../images/limasol.jpg")
        },
        {
            "title" : translations.eventsList[0].title,
            "location" : translations.eventsList[0].location,
            "date" : translations.eventsList[0].date,
            "img" : require("../../images/IMG_8899.PNG")
        },
        {
            "title" : translations.eventsList[1].title,
            "location" : translations.eventsList[1].location,
            "date" : translations.eventsList[1].date,
            "img" : require("../../images/IMG_8844.PNG")
        },
        {
            "title" : translations.eventsList[2].title,
            "location" : translations.eventsList[2].location,
            "date" : translations.eventsList[2].date,
            "img" : require("../../images/IMG_8837.jpeg")
        },
        {
            "title" : translations.eventsList[3].title,
            "location" : translations.eventsList[3].location,
            "date" : translations.eventsList[3].date,
            "img" : require("../../images/IMG_8832.jpeg")
        },
        {
            "title" : translations.eventsList[4].title,
            "location" : translations.eventsList[4].location,
            "date" : translations.eventsList[4].date,
            "img" : require("../../images/IMG_8841.PNG")
        },
        {
            "title" : translations.eventsList[5].title,
            "location" : translations.eventsList[5].location,
            "date" : translations.eventsList[5].date,
            "img" : require("../../images/IMG_8838.jpeg")
        },
        {
            "title" : translations.eventsList[6].title,
            "location" : translations.eventsList[6].location,
            "date" : translations.eventsList[6].date,
            "img" : require("../../images/IMG_8833.PNG")
        }
    ];
    const imgAdvImages = {
        arrow: require('../../images/material-symbols_line-end-arrow-outline.png')
    }

    const [isMobile , setIsMobile] = useState(false)
    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 480px)'); // Установите нужный вам медиа-запрос
        const handleResize = (event) => {
            setIsMobile(event.matches);
        };
        mediaQuery.addListener(handleResize);
        setIsMobile(mediaQuery.matches);
        return () => {
            mediaQuery.removeListener(handleResize);
        };

    }, [isMobile]);

    const CustomNextArrow = (props) => (
        <button className="event_link" onClick={props.onClick}>
            <img src={imgAdvImages.arrow} alt="->"/>
        </button>
    );
    const CustomPrevArrow = (props) => (
        <button className="event_link prev_arrow" onClick={props.onClick}>
            <img src={imgAdvImages.arrow} alt="->"/>
        </button>
    );

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow : <CustomPrevArrow/>,
        nextArrow: <CustomNextArrow />
    };



    return(
        <div className='events'>
            <div className='events_header'>
                <h1 className='events_header_title'>{translations.eventsPageTitle}</h1>
                {/*<span className='events_header_link'>see all</span>*/}
            </div>
            {
                isMobile ?
                    <Slider className='event_slider' {...settings}>
                        {
                            arrEvent.map(function (item, i) {
                                return (
                                    <EventItem key={i} title={arrEvent[i].title} date={arrEvent[i].date} location={arrEvent[i].location} img={arrEvent[i].img}/>
                                )
                            })
                        }

                    </Slider>

                    :
                    <OverflowScrolling className='overflow-scrolling-events events_list'>

                        {
                            arrEvent.map(function (item, i) {
                                return (
                                    <EventItem key={i} title={arrEvent[i].title} date={arrEvent[i].date} location={arrEvent[i].location} img={arrEvent[i].img}/>
                                )
                            })
                        }

                    </OverflowScrolling>
            }
        </div>
    )
}